import { PublicKey } from '@solana/web3.js'
import Decimal from 'decimal.js'
import { toUiDecimals } from './tokens'
import { USDC_MINT, USDG_MINT, USDT_MINT, WRAPPED_SOL_MINT } from './constants'
import { TOKEN_PROGRAM_ID } from '@solana/spl-token'
import { tryGetPubKey } from './governance/tools'

export const SOL_DECIMALS = 9

export const FULL_FEE_BPS = 10

export const REBATED_FEE_BPS = 9

export const ZERO_FEE_BPS = 0

export const calcFeeParams = (
  outAmountNative: string,
  hasRef: boolean,
  outTokenDecimals: number,
  tokenUiPrice: number,
  solUiPrice: number,
  outMint: string,
  outTokenProgram: string,
  inputMint: string,
) => {
  if (
    !outMint ||
    !solUiPrice ||
    !tokenUiPrice ||
    tryGetNumber(outAmountNative) === 0 ||
    tryGetNumber(outAmountNative) < 0
  ) {
    return null
  }
  const feeBps = freePairs(inputMint, outMint)
    ? ZERO_FEE_BPS
    : Math.round(hasRef ? REBATED_FEE_BPS : FULL_FEE_BPS)

  try {
    const mint = new PublicKey(outMint)
    const program = tryGetPubKey(outTokenProgram) || TOKEN_PROGRAM_ID
    let feeMint = mint
    let feeProgram = program

    let feeNative = new Decimal(outAmountNative).mul(
      new Decimal(feeBps / 10000),
    )

    let outAmount = new Decimal(outAmountNative).sub(feeNative)

    const feeValueUi =
      toUiDecimals(Math.round(feeNative.toNumber()), outTokenDecimals) *
      tokenUiPrice

    // if fee is lower than 1$ and fee mint is not sol or usdc we charge in wsol
    if (
      feeValueUi <= 1 &&
      !(mint.equals(WRAPPED_SOL_MINT) || mint.equals(new PublicKey(USDC_MINT)))
    ) {
      feeMint = WRAPPED_SOL_MINT
      feeNative = new Decimal(feeValueUi)
        .div(solUiPrice)
        .mul(10 ** SOL_DECIMALS)
      outAmount = new Decimal(outAmountNative)
      feeProgram = TOKEN_PROGRAM_ID
    }

    return {
      fee: Math.round(feeNative.toNumber()),
      feeMint,
      outAmount: Math.round(outAmount.toNumber()),
      feeProgram,
    }
  } catch (e) {
    console.error(
      `Error in calcFeeParams: outAmountNative=${outAmountNative}, hasRef=${hasRef}, outTokenDecimals=${outTokenDecimals}, tokenUiPrice=${tokenUiPrice}, solUiPrice=${solUiPrice}, outMint=${outMint}, outTokenProgram=${outTokenProgram}`,
      e,
    )
    return null
  }
}

export const tryGetNumber = (val: string) => {
  try {
    return !isNaN(Number(val)) ? Number(val) : 0
  } catch (e) {
    return 0
  }
}

export const freePairs = (
  inputMint: string | undefined,
  outputMint: string | undefined,
) => {
  return (
    (inputMint === USDT_MINT || inputMint === USDC_MINT) &&
    outputMint === USDG_MINT
  )
}
